import React from "react";
import { HvButton, HvButtonProps } from "@hitachivantara/uikit-react-core";
import { Add } from "@hitachivantara/uikit-react-icons";
import useStyles from "./styles";

const AddButton: React.FC<HvButtonProps> = ({ onClick, children }) => {
  const classes = useStyles();
  return (
    <HvButton
      className={classes.add}
      category="semantic"
      startIcon={<Add />}
      onClick={onClick}
    >
      {children}
    </HvButton>
  );
};

export default AddButton;
